export default __webpack_public_path__ + "static/deep-cf1b84e39bd811131b4c69f420260351.png";